import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { SwatchBook } from "lucide-react";
import type { GlaSelectorTriggerSizeClasses } from "../triggerSizes";

interface GLASelectorTriggerProps {
    placeholder: string;
    sizeClasses: GlaSelectorTriggerSizeClasses;
}

export function GLASelectorTrigger({ placeholder, sizeClasses }: GLASelectorTriggerProps) {
    return (
        <>
            <SwatchBook className={`${sizeClasses.triggerIcon} shrink-0 text-gray-400`} />
            <span className="min-w-0 truncate text-gray-500">{placeholder}</span>
            <span
                className={`pointer-events-none absolute inset-y-0 right-0 flex items-center ${sizeClasses.chevronInset}`}
            >
                <ChevronDownIcon
                    className={`${sizeClasses.chevron} text-gray-400 transition-transform group-data-[open]:rotate-180`}
                />
            </span>
        </>
    );
}
